import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getProductStocks({ commit }, params = {}) {
    return axios.get('/products-stocks', { params })
  },
  searchProductStocks({ commit }, params = {}) {
    return axios.get('/products-stocks/search', { params })
  },
}
